<template>
  <p>
    This VIZBI Showcase event — 'Twin Lenses on the Dance of Life' —
    {{ tense("is", "was") }} an evening outreach event exploring how data visualization and science
    communication can bring biological ideas to a wider audience. It {{ tense("is", "was") }} open
    to all
    <a href=".">VIZBI {{ selectedYear }}</a> Workshop and DataVis Masterclass attendees, as well as
    friends, family, and members of the general public.
  </p>

  <a>
    <HeroImage hero-image="/Showcase/2026.jpg" />
  </a>

  <p>
    The Showcase {{ tense("takes", "took") }} place {{ time }}, {{ date }}, at
    <a href="https://maps.app.goo.gl/ertvDocvpcv6Uq7U9">The Hub, Francis Crick Avenue</a> in
    Cambridge, UK.<template v-if="!isPast">
      Tickets £15–£25, including drinks and light snacks, with discounts available (e.g. for
      students).</template
    >
  </p>

  <RegisterNowWrapper v-if="!isPast" />

  <h4>Twin Lenses on the Dance of Life</h4>
  <p>
    Life moves in patterns we can barely perceive—some unfold in the hidden architecture of our
    cells, others sweep across vast coastal skies. {{ tense("Tonight’s", "The") }} showcase
    {{ tense("brings", "brought") }} together
    <strong>two filmmakers</strong> devoted to revealing these rhythms, working at
    <strong>opposite ends of the scale of existence</strong> yet united by a common vision: to make
    visible the <strong>choreography that sustains life</strong>.
  </p>

  <p>
    <a href="#Maja_Divjak"><strong>Maja Divjak</strong></a> descends into the molecular realm,
    wielding the tools of <strong>scientific animation</strong> to illuminate the epigenetic waltz
    occurring inside every cell. Her <strong>“Methylation Mambo”</strong> shows how cancer can arise
    not from broken genetic code, but from <strong>disrupted molecular switches</strong>—processes
    that can, remarkably, be reversed. Through meticulous <strong>3D animation</strong>, she
    translates the invisible into the comprehensible.
  </p>

  <p>
    <a href="#Martin_Dohrn"><strong>Martin Dohrn</strong></a> points his high-speed cameras skyward,
    capturing the astonishing <strong>aerial ballets</strong> of wading birds over England’s Wash
    estuary. His <strong>time-lapse cinematography</strong> compresses hours into moments, revealing
    patterns shaped by <strong>evolutionary pressures</strong>—the ancient geometry of predator and
    prey, written across marshland skies. The work is both <strong>scientific document</strong> and
    <strong>personal meditation</strong>.
  </p>

  <p>
    <strong>One filmmaker renders the submicroscopic. The other captures the sublime.</strong>
    Together, they remind us that the <strong>dance of life</strong> unfolds at every scale—from the
    methylation of a single DNA base to the coordinated flight of
    <strong>ten thousand wings</strong>.
  </p>

  <!-- <p>
    Expect a relaxed, social atmosphere with short talks and visual work that highlight the craft of
    communicating complex biology clearly — and the role of visualization in making that possible.
    It’s also a chance for the VIZBI community and the wider Cambridge public to meet, share ideas,
    and connect across disciplines.
  </p> -->

  <!-- before the speakers were announced
  <p>
    Speaker details and the full program will be announced soon. Please check back here, or follow
    VIZBI communications for updates.
  </p>
  -->

  <p>
    <b>Organization:</b>
    This outreach event {{ tense("is", "was") }} organized by <a href=".">VIZBI {{ selectedYear }}</a
    >, the {{ fullMeetingTitle }}.
  </p>

  <p>For any questions, please contact <Email to="vizbi-contact" />.</p>
</template>

<script setup>
import Email from "@/components/Email";
import HeroImage from "@/components/HeroImage";
import RegisterNowWrapper from "@/components/CallToAction/RegisterNowWrapper";
import useSessionDateTime from "@/composables/useSessionDateTime";
import {inject} from "vue";
import useTense from "@/composables/useTense";
// import ButtonBespoke from "@/components/ButtonBespoke";
// import MaskedVideo from "@/components/MaskedVideo";
//import InnerSpaceMask from ";
// const props = defineProps({devOnly: Boolean}); // hide on vizbi.org
const selectedYear = inject("selectedYear");
const fullMeetingTitle = inject("fullMeetingTitle");
const {date, time} = useSessionDateTime("Showcase");
const {tense, isPast} = useTense("2026-04-17"); // the Showcase's evening

</script>

<style scoped>
h3 {
  display: inline;
}
h4 {
  font-weight: 800;
  font-size: 1rem;
  margin-top: 0.3rem;
}
p button {
  margin-top: 16px;
  margin-bottom: 16px;
}
</style>
